var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesetaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 160H348.766C333.896 87.062 269.262 32 192 32H72C49.906 32 32 49.906 32 72V160C14.328 160 0 174.312 0 192S14.328 224 32 224V440C32 462.094 49.906 480 72 480S112 462.094 112 440V352H192C269.262 352 333.896 296.938 348.766 224H352C369.672 224 384 209.688 384 192S369.672 160 352 160ZM112 112H192C224.723 112 252.844 131.791 265.223 160H112V112ZM192 272H112V224H265.223C252.844 252.209 224.723 272 192 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesetaSign);
export default __webpack_public_path__ + "static/media/peseta-sign.78e0cb32ac7b24d0ef628f248a90deb2.svg";
export { ForwardRef as ReactComponent };